<template>
  <div class="public-content order">
    <div class="breadcrumb">SKU组日志</div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="编号" prop="id" min-width="10px"></el-table-column>
          <el-table-column prop="method" label="操作项" min-width="10px"></el-table-column>
          <el-table-column prop="createdName" label="操作人" min-width="10"></el-table-column>
          <el-table-column prop="createdTime" label="操作时间" min-width="10"></el-table-column>
        </el-table>
        <p>
          <el-button class="bottom_button" type="primary" @click="$router.go(-1)" round>返回</el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { skuGroupLog } from '@/api/pms'
export default {
  name: 'order',
  data () {
    return {
      tableData: []
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSkuGroupLog()
  },
  methods: {
    getSkuGroupLog () {
      skuGroupLog(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

.bottom_button {
  margin-top: 20px;
  float: right;
  margin-right: 20px;
  margin-bottom: 20px;
}
</style>
